export class Mesh {
}
export class WidthHeight {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
}
export class Vector2 {
    constructor(x = NaN, y = NaN) {
        this.x = NaN;
        this.y = NaN;
        this.x = x;
        this.y = y;
    }
    apply(func) {
        return new Vector2(func(this.x), func(this.y));
    }
    static max(v, w) {
        return new Vector2(Math.max(v.x, w.x), Math.max(v.y, w.y));
    }
    static componentAdd(a, b) {
        return new Vector2(a.x + b.x, a.y + b.y);
    }
    static componentSubtract(a, b) {
        return new Vector2(a.x - b.x, a.y - b.y);
    }
    clone() {
        return new Vector2(this.x, this.y);
    }
}
Vector2.multiplyComponents = (v, w) => {
    return new Vector2(v.x * w.x, v.y * w.y);
};
export class Strecke {
    constructor(start, end) {
        this.end = end;
        this.start = start;
    }
    asArray() {
        return [this.start, this.end];
    }
}
export class Vector2WithUV extends Vector2 {
    constructor(x = NaN, y = NaN, u = NaN, v = NaN) {
        super(x, y);
        this.u = NaN;
        this.v = NaN;
        this.u = u;
        this.v = v;
    }
    apply(func) {
        super.apply(func);
        this.u = func(this.u);
        this.v = func(this.v);
        return this;
    }
}
export class ContentWithLevel {
    constructor(content, level) {
        this.content = content;
        this.level = level;
    }
}
//# sourceMappingURL=delme_globals.js.map